import { useState } from 'react';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';
import { step2ValidationSchema } from './step2.validation';
import { useFormik } from 'formik';

export const useStep2 = () => {
  const { formulario, setPartialForm, salvarRascunho } =
    useFormularioSecretariaMunicipalAgriculturaStore();

  const [submittedOnce, setSubmittedOnce] = useState<boolean>(false);
  const stepAtual = formulario?.step_atual ?? 1;
  const totalSteps = 8;

  const handleSave = (values: any) => {
    setPartialForm('fundo_municipal_agricultura_familiar', values.fundo_municipal_agricultura_familiar);
    setPartialForm('tipo_publicacao', values.tipo_publicacao);
    setPartialForm('nro_publicacao', values.nro_publicacao);
    setPartialForm('data_publicacao', values.data_publicacao);
  };

  const formik = useFormik({
    initialValues: {
      fundo_municipal_agricultura_familiar: formulario?.fundo_municipal_agricultura_familiar,
      tipo_publicacao: formulario?.tipo_publicacao ?? '',
      nro_publicacao: formulario?.nro_publicacao,
      data_publicacao: formulario?.data_publicacao,
    },
    validationSchema: step2ValidationSchema,
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: (values: any) => {
      handleSave(values);
      setPartialForm('step_atual', stepAtual + 1);
      salvarRascunho();
    },
  });

  const handleAvancar = async () => {
    setSubmittedOnce(true);
    await formik.submitForm();
  };

  const handleVoltar = async () => {
    setPartialForm('step_atual', Math.max(1, stepAtual - 1));
  };

  return { formik, handleAvancar, handleVoltar, stepAtual, totalSteps };
};
